import { useState } from "react";
import { C } from "../utils/tokens";
import { Tag, Btn, Card, Field, FInput, FTA } from "../components/primitives";
import { validatePeriodo } from "../utils/validation";

const ErrMsg = ({ msg }) =>
  msg ? (
    <div style={{ fontSize: 11, color: C.danger, marginTop: 3 }}>{msg}</div>
  ) : null;

const Step2 = ({ d, s }) => {
  const [errors, setErrors] = useState({});
  const add = () =>
    s([
      ...d,
      { id: Date.now(), azienda: "", ruolo: "", periodo: "", descrizione: "" },
    ]);
  const u = (id, k, v) => s(d.map((e) => (e.id === id ? { ...e, [k]: v } : e)));
  const del = (id) => s(d.filter((e) => e.id !== id));

  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: 20 }}
      className="au"
    >
      <div>
        <h2
          style={{
            fontFamily: "'Syne',sans-serif",
            fontSize: 26,
            fontWeight: 800,
            marginBottom: 5,
          }}
        >
          Esperienza lavorativa
        </h2>
        <p style={{ color: C.muted, fontSize: 13.5 }}>Dalla più recente.</p>
      </div>
      {d.map((e, i) => (
        <Card key={e.id}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 14,
            }}
          >
            <Tag>Posizione {i + 1}</Tag>
            {d.length > 1 && (
              <Btn size="sm" variant="danger" onClick={() => del(e.id)}>
                ✕
              </Btn>
            )}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 12,
              }}
            >
              <Field label="Azienda">
                <FInput
                  value={e.azienda}
                  onChange={(v) => u(e.id, "azienda", v)}
                  placeholder="Google, ENEL..."
                />
              </Field>
              <Field label="Ruolo">
                <FInput
                  value={e.ruolo}
                  onChange={(v) => u(e.id, "ruolo", v)}
                  placeholder="Senior Dev, Insegnante..."
                />
              </Field>
            </div>
            <Field
              label="Periodo"
              hint="Es: Gen 2020 – Dic 2023  o  2020 – Oggi"
            >
              <FInput
                value={e.periodo}
                onChange={(v) => u(e.id, "periodo", v)}
                onBlur={() =>
                  setErrors((er) => ({
                    ...er,
                    [e.id]: validatePeriodo(e.periodo),
                  }))
                }
                placeholder="Gen 2020 – Oggi"
              />
              <ErrMsg msg={errors[e.id]} />
            </Field>
            <Field label="Descrizione attività">
              <FTA
                value={e.descrizione}
                onChange={(v) => u(e.id, "descrizione", v)}
                placeholder="Cosa hai fatto, risultati concreti..."
                rows={3}
              />
            </Field>
          </div>
        </Card>
      ))}
      <button
        onClick={add}
        style={{
          padding: 13,
          border: `1px dashed ${C.goldBorder}`,
          borderRadius: 10,
          background: C.goldDim,
          color: C.gold,
          fontSize: 13,
          fontFamily: "'Syne',sans-serif",
          transition: "all 0.18s",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.borderColor = C.gold)}
        onMouseLeave={(e) => (e.currentTarget.style.borderColor = C.goldBorder)}
      >
        + Aggiungi esperienza
      </button>
    </div>
  );
};

export default Step2;
